export const fontSize = {
  xxl: '2rem', //32px
  xl: '1.5rem', //24px
  lg: '1.125rem', //18px
  md: '1rem', //16px
  sm: '0.875rem', //14px TODO: fix this
  xs: '0.875rem', //14px
  xxs: '0.75rem', //12px
};
